import { render } from "./AppFileModal.vue?vue&type=template&id=f4cf838e"
import script from "./AppFileModal.vue?vue&type=script&lang=js"
export * from "./AppFileModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__